import { IS_NEODENT } from '../../config/constants';

export const isNeodentOrganization = (): boolean => {
    console.log('IS_NEODENT constant:', IS_NEODENT);
    return IS_NEODENT;
};

export const useIsNeodentOrganization = (): boolean => {
    console.log('useIsNeodentOrganization called, IS_NEODENT:', IS_NEODENT);
    return IS_NEODENT;
};
